import { render } from "./ReportEmbed.vue?vue&type=template&id=8dde9744"
import script from "./ReportEmbed.vue?vue&type=script&lang=js"
export * from "./ReportEmbed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\release-RPTWEB-3002\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__